import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import authStorage from "./utils/authStorage";

type Prop = {
  children: React.ReactElement;
};

export default function WithAuth({ children }: Prop) {
  const accessToken = authStorage.get()?.accessToken;
  const navigate = useNavigate();
  const location = useLocation();
  // const { data: webUpdateData } = useGetWebUpdate();

  // IE 또는 IE 모드 감지

  useEffect(() => {
    const isIE =
      navigator.userAgent.includes("Trident") ||
      navigator.userAgent.includes("MSIE");

    if (isIE) {
      // 사용자 알림
      alert(
        "이 애플리케이션은 Internet Explorer 모드에서 지원되지 않습니다. Microsoft Edge 또는 최신 브라우저를 사용해 주세요."
      );
    }
  }, []);

  // 함양군 href에 www 체크
  useEffect(() => {
    const origin = window.location.origin;
    const pathname = window.location.pathname;

    if (origin.includes("www")) {
      const newOrigin = origin.replace("www.", "");
      // console.log(`www 감지되어 ${newOrigin} 으로 이동`);
      window.location.href = newOrigin + pathname;
      return;
    }
  }, [location]);

  useEffect(() => {
    // let isUpdatingTime =
    //   webUpdateData &&
    //   webUpdateData.code === 2000 &&
    //   new Date(webUpdateData.result.start_date) <= new Date() &&
    //   new Date(webUpdateData.result.end_date) >= new Date();

    // 로그인 유저가 아닌데 페이지 접근
    if (
      !accessToken &&
      location.pathname !== `/login`
      //  && webUpdateData &&
      // webUpdateData.result
    ) {
      navigate(`/login`, {
        replace: true,
      });
      // // 업데이트중이 아니면 로그인 페이지로 이동
      // if (!isUpdatingTime) {
      //   navigate(`/login`, {
      //     replace: true,
      //   });
      // }
      // // 업데이트중이면 업데이트 페이지로 이동
      // else if (isUpdatingTime) {
      //   navigate(`/maintenance`);
      // }
    }
  }, [navigate, location.pathname, accessToken]);

  // 카카오맵 parser-blocking 경고가 콘솔에 출력될때 카카오맵 API appkey가 노출되는것을 방지하기 위해
  // 페이지 이동 (새로고침)할 때마다 콘솔 클리어함

  useEffect(() => {
    if (!window.location.href.includes("dev")) {
      console.clear();
    }
  }, []);

  return children;
}
